import { FontWeight } from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import { gsap } from "gsap";
import { Text } from "pixi.js";

import { AbstractSymbol } from "../../../../abstracts/elements/AbstractSymbol";
import { AbstractBitmapText } from "../../../../abstracts/graphics/AbstractBitmapText";
import { AbstractView } from "../../../../abstracts/modules/AbstractView";
import { AbstractWinScreen } from "../../../../abstracts/modules/screens/AbstractWinScreen";
import { fitDisplayObjectToWidth } from "../../../../abstracts/utils/GraphicUtils";
import { Apocalypse } from "../../../Apocalypse";
import { ApocalypseFontsNames } from "../../../assetsLoader/ApocalypseAssetsNames";
import { winFontSize } from "../../../config/ApocalypseConfig";

export class ApocalypseWaysWinScreen extends AbstractWinScreen {
    protected waysWinText: Text;

    constructor(parentContainer: AbstractView) {
        super(`ApocalypseWaysWinScreen`, parentContainer);
    }

    protected init(): void {
        super.init();

        this.totalWinText = new AbstractBitmapText({
            text: `0`,
            style: {
                fontName: ApocalypseFontsNames.APOCALYPSE_BLUE,
                fontSize: winFontSize,
            },
        });
        this.totalWinText.name = `totalWinText`;
        this.addChild(this.totalWinText);

        this.waysWinText = new Text(`WAYS`, {
            dropShadow: true,
            dropShadowAngle: 8,
            dropShadowBlur: 10,
            dropShadowDistance: 2,
            fontFamily: `Helvetica`,
            fontWeight: FontWeight.BOLD,
            // fontStyle: `italic`,
            fontSize: 42,
            align: `center`,
            wordWrap: true,
            wordWrapWidth: 560,
            fill: [`#f7c238`, `#c77826`],
        });
        this.waysWinText.name = `waysWinText`;
        this.waysWinText.y = 48;
        this.addChild(this.waysWinText);
    }

    public handleWaysWin(
        symbols: AbstractSymbol[],
        winAmounts: number[],
        waysNo: number,
        duration: number = 0.5
    ): gsap.core.Timeline {
        super.handleWaysWin(symbols, winAmounts, waysNo);

        const tl = gsap.timeline({
            onUpdate: () => {
                fitDisplayObjectToWidth(this.totalWinText, 700);
            },
        });

        const showWinText = gsap.fromTo(
            this.totalWinText,
            { alpha: 0 },
            {
                alpha: 1,
                duration: 0.2 * duration,
                onStart: () => {
                    this.parentContainer.addChild(this);

                    this.totalWinText.updateValue(winAmounts[0].toFixed(2).toString());
                    this.totalWinText.y = waysNo === -1 ? 14 : -10;

                    this.waysWinText.alpha = 0;
                },
            }
        );
        tl.add(showWinText, 0);

        const hideWinText = gsap.fromTo(
            this.totalWinText,
            { alpha: 1 },
            {
                alpha: 0,
                duration: 0.1 * duration,
                ease: `none`,
                onComplete: () => {
                    this.parentContainer.removeChild(this);
                },
            }
        );
        tl.add(hideWinText, 0.9 * duration);

        if (waysNo !== -1) {
            const showWaysText = gsap.fromTo(
                this.waysWinText,
                { alpha: 0 },
                {
                    alpha: 1,
                    duration: 0.2 * duration,
                    onStart: () => {
                        this.waysWinText.text = `${waysNo} ${
                            waysNo > 1
                                ? Apocalypse.apiPlugin.translations.translate(`Ways Won`)
                                : Apocalypse.apiPlugin.translations.translate(`Way Won`)
                        }`.toUpperCase();
                        this.waysWinText.x = -this.waysWinText.width / 2;
                    },
                }
            );
            tl.add(showWaysText, 0);

            const hideWaysText = gsap.fromTo(
                this.waysWinText,
                { alpha: 1 },
                {
                    alpha: 0,
                    duration: 0.1 * duration,
                    ease: `none`,
                }
            );
            tl.add(hideWaysText, 0.9 * duration);
        }

        return tl;
    }
}
